import { render, staticRenderFns } from "./UpArrow.vue?vue&type=template&id=56636dad&"
import script from "./UpArrow.vue?vue&type=script&lang=js&"
export * from "./UpArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports